export default __webpack_public_path__ + "static/media/all-good-pending.3d398b4a.svg";